export default __webpack_public_path__ + "static/media/giantsquidraw.e768210f.PNG";